<footer *ngIf="footerSettingsVM.showFooter == true" class="border-top footer text-muted  mt-0 mt-sm-3">
	<div class="container py-3">
		<div class="row text-center font-12">
			<div class="col"><a href="{{footerSettingsVM.contactUsUrl}}">Contact Us</a></div>
			<div class="col"><a href="{{footerSettingsVM.termsOfServiceUrl}}">Terms of Use</a></div>
			<div class="col"><a href="{{footerSettingsVM.privacyPolicyUrl}}">Privacy Policy</a></div>
		</div>
	</div>
  </footer>